import * as React from 'react';
import { MenuItem, FormControl, Select, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SearchStyle } from '../../pages/PatientManagement/style';

interface Option {
  label: string;
  value: string;
}

interface Props {
  dropdownValue: string;
  handleDropdownChange: (arg: string) => void;
  dropdownList: Option[];
}

export default function SelectBox({ dropdownValue, handleDropdownChange, dropdownList }: Props) {
  const { t } = useTranslation();

  return (
    <SearchStyle>
      <Box className="form-control-style">
        <FormControl sx={{ minWidth: 100 }}>
          <Select
            MenuProps={{
              disableScrollLock: true
            }}
            value={dropdownValue}
            onChange={(e) => handleDropdownChange(e.target.value)}
            displayEmpty
            name="registrationRange">
            {dropdownList?.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {t(option.label)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </SearchStyle>
  );
}
